import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import caristasImg from "../../assets/Mask group (6).png";
// import Search from "../../components/Search";
import InviteEnv from "../../assets/inviteEnvelope.png";
// import { Link } from "react-router-dom";
import { Btn, RoundedBtn } from "../../components/button.jsx/Btn";
import { InviteModal } from "../../components/modal";

export default function StudentsTable() {
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [inviteEmail, setInviteEmail] = useState("");

  const navigate = useNavigate(); // Use navigate for navigation

  const students = [
    {
      image: caristasImg,
      name: "Caristas Rising Academy",
      username: "21st June, 2024",
      email: "emailaddress@gmail.com",
    },

    {
      image: caristasImg,
      name: "Caristas Rising Academy",
      username: "21st June, 2024",
      email: "emailaddress@gmail.com",
    },

    {
      image: caristasImg,
      name: "Caristas Rising Academy",
      username: "21st June, 2024",
      email: "emailaddress@gmail.com",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      username: "21st June, 2024",
      email: "emailaddress@gmail.com",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
    {
      image: caristasImg,
      name: "Caritas Rising Academy",
      email: "emailaddress@gmail.com",
      username: "21st June, 2024",
    },
  ];

  const filteredStudents = students.filter((student) =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Open

  // Open Invite Modal

  const openInviteModal = () => {
    setIsModalOpen(false);
    setIsInviteModalOpen(true);
  };

  const closeInviteModal = () => setIsInviteModalOpen(false);

  // Success Modal
  const handleInviteSubmit = (ev) => {
    ev.preventDefault();
    setIsInviteModalOpen(false);
    setIsSuccessModalOpen(true);
  };

  const viewInstitution = () => {
    navigate("/institution/institutionPage");
  };

  return (
    <div className="p-6 text-xs bg-white rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-x-10 w-10/12">
          <h1 className="text-[#400167] text-lg font-bold ">All Institution</h1>
        </div>
        <Btn onClick={openInviteModal}>+ New Invite</Btn>

        {/* <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
        >
          <div className="my-10">
            <h1 className="text-[#400167] text-[20px] leading-[27px] font-[700] mb-2">
              Add New Student
            </h1>
            <p className="text-[14px] leading-[18.9px] text-[#74777B]">
              You can invite a new student or add existing student
            </p>
            <div className="mt-6">
              <Link onClick={openInviteModal}>
                <div className="text-[#000000] font-satoshi underline font-[400] mb-3">
                  Invite Student
                </div>
              </Link>
              <Link>
                <div className="text-[#000000] font-satoshi underline font-[400] mb-3">
                  Add Existing Student
                </div>
              </Link>
            </div>
          </div>

          <div className="m-8">
            <div>
              <img
                src={InviteEnv}
                alt="inviteImg"
              />
            </div>

            <div>
              <h1 className=" text-[#400167] font-[900] text-[24px]">
                Invite Institution to CELMA
              </h1>
              <p className=" text-[#10021D] text-sm font-[400] ">
                Enter email addresses below to invite institutions to join
              </p>
            </div>
          </div>
        </Modal> */}

        <InviteModal
          isOpen={isInviteModalOpen}
          onClose={closeInviteModal}
        >
          <div className="">
            <div className=" grid py-2 justify-center items-center">
              <div>
                <img
                  src={InviteEnv}
                  alt="inviteImg"
                  className=" w-20 mx-auto"
                />
              </div>

              <div>
                <h1 className=" text-[#400167] text-center mb-6 font-[900] text-xl">
                  Invite Institution to CELMA
                </h1>
                <p className=" text-[#10021D] text-sm font-[400] ">
                  Enter email addresses below to invite institutions to join
                </p>
              </div>
            </div>
            <form
              className=""
              onSubmit={handleInviteSubmit}
            >
              <label
                htmlFor="invite-email"
                className="block mb-2 font-[500] text-[14px] text-[#0B2239] leading-[18.9px] font-satosh"
              >
                Email Address
              </label>
              <input
                type="email"
                id="invite-email"
                value={inviteEmail}
                onChange={(ev) => setInviteEmail(ev.target.value)}
                className="w-full p-2 h-[160px] rounded-lg focus:outline-none border-0 bg-[#F3F5F5]"
              />
              <div className="mt-4 flex justify-center">
                <RoundedBtn
                  type="submit"
                  className="font-[700] font-satoshi  leading-[21.6px] w-full rounded-full text-white py-[16px] bg-[#5002D0]  h-[60px] mt-10 text-[16px] "
                >
                  <span>Send Invite</span>
                </RoundedBtn>
              </div>
            </form>
          </div>
        </InviteModal>
      </div>

      <Table
        students={filteredStudents}
        onViewInstitution={viewInstitution}
      />
    </div>
  );
}

function Table({ students, onViewInstitution }) {
  return (
    <table className="w-full bg-white">
      <thead>
        <tr className=" uppercase font-[600] text-sm text-[8px] font-Nunito">
          <th className="py-2 px-4 text-left text-[#3F3F3F]  font-light">
            Institution Name
          </th>
          <th className="py-2 px-4 text-left text-[#3F3F3F]  font-light">
            Date created
          </th>
          <th className="py-2 px-4 text-left text-[#3F3F3F]  font-light">
            Email Address
          </th>
          <th className="py-2 px-4 text-left text-[#3F3F3F]  font-light">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {students.map((student, index) => (
          <Student
            key={index}
            student={student}
            onViewInstitution={onViewInstitution}
          />
        ))}
      </tbody>
    </table>
  );
}

function Student({ student, onViewInstitution }) {
  return (
    <tr>
      <div className=" flex items-center">
        <img
          className=" w-6 h-6"
          src={student.image}
          alt="caristaImg"
        />
        <td className="py-2 font-semibold px-4 text-xs">{student.name}</td>
      </div>
      <td className="py-2 px-4 text-xs">{student.username}</td>
      <td className="py-2 px-4 text-xs">{student.email}</td>
      <td className="py-2 px-4 text-xs">
        <button
          onClick={onViewInstitution}
          className="bg-[#DDD3FF] text-[#5002D0] rounded-[8px] py-2 px-4  hover:bg-purple-200 text-xs"
        >
          Show details
        </button>
      </td>
    </tr>
  );
}
